// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"675":"0e6137db","779":"a64bf07f","787":"69d88f0e"}[chunkId] + ".chunk.js";
};